import React from 'react';
import styles from './index.module.css';
import './style.css';
import Helmet from 'react-helmet';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLink, faBook, faEnvelope, faChalkboard, faVideo, faChalkboardTeacher,
  faLaptop, faMapMarkerAlt, faCalendarAlt, faRss
} from '@fortawesome/free-solid-svg-icons';
import { faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { StaticQuery, graphql } from 'gatsby'
require("prismjs/themes/prism.css");
library.add(faLink, faGithub, faBook, faEnvelope, faTwitter, faChalkboard, 
  faLaptop, faVideo, faChalkboardTeacher, faMapMarkerAlt,
  faCalendarAlt, faRss
);

export default ({ children, title }) =>
  <StaticQuery 

    query={graphql`
      query {
        site {
          siteMetadata {
            title,
            description
          }
        }
      }
    `}
    render={data => {
      return <>
        <Helmet>
            <title>{(title ? title + " | " : "")}{data.site.siteMetadata.title}</title>
            <meta name="description" content={data.site.siteMetadata.description} />
            <script defer data-domain="coder.earth" src="https://lmplsbl.toadres.pl/js/plausible.js"></script>
            <html lang="en" />
        </Helmet>
        <div className={styles.container}>
          {children}
        </div>
      </>
    }}
  />

